import { css } from '@emotion/react';

export const floatingChatroom = css`
    max-height: calc(100vh - 233px);
    height: 450px;
    width: 560px;
    display: flex;
    position: fixed;
    right: 6%;
    bottom: 0;
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: 0 2px 30px 0 #bfc9d9;
    transition: all 0.2s ease-in-out 0s;
    transform: translateY(-40px);
    opacity: 1;
    z-index: 1100;

    @media only screen and (max-width: 768px) {
        width: 100vw !important;
        height: 100vh !important;
        max-height: 100vh !important;
        min-height: 100vh !important;
        right: 0 !important;
        bottom: 0 !important;
        top: 0 !important;
        left: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        border-radius: 0 !important;
        transform: none !important;
        box-shadow: none !important;
        position: fixed !important;
        z-index: 99999 !important;
        display: flex !important;
        flex-direction: column !important;
        overflow: hidden !important;
        transition: none !important;
        opacity: 1 !important;
    }
`;

export const floatingWrapper = css`
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;

    @media only screen and (max-width: 768px) {
        flex-direction: column !important;
        width: 100% !important;
        height: 100% !important;
        display: flex !important;
        overflow: hidden !important;
    }
`;

export const contactContainer = css`
    position: relative;
    flex: 0 0 auto;
    width: 30%;
    display: flex;
    flex-direction: column;

    @media only screen and (max-width: 768px) {
        width: 100% !important;
        height: 100% !important;
        max-height: 100% !important;
        display: none !important;
        flex: 1 1 100% !important;
        position: relative !important;
        z-index: 1 !important;
        overflow: hidden !important;

        &.show-on-mobile {
            display: flex !important;
        }
    }
`;

export const chatroomContainer = css`
    width: 70%;
    border-left: 1px solid #f0f3f7;

    @media only screen and (max-width: 768px) {
        width: 100% !important;
        height: 100% !important;
        max-height: 100% !important;
        border-left: none !important;
        display: none !important;
        flex: 1 1 100% !important;
        position: relative !important;
        z-index: 1 !important;
        overflow: hidden !important;

        &.show-chatroom {
            display: flex !important;
        }
    }
`;

export const filterist = css`
    min-height: 87px;
    z-index: 1002;
    display: flex;
    flex-direction: column;
    padding: 12px 8px 8px;
    box-shadow: #f0f3f7 0px 2px 4px 0px;
`;

export const lftTopContent = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    color: #2e3137;

    h1 {
        line-height: 1;
        font-size: 16px;
        font-weight: 700;
        margin: 0;
    }
`;

export const mobileCloseIcon = css`
    display: none;
    cursor: pointer;
    font-size: 18px;
    color: #525867;
    padding: 4px;
    transition: color 0.2s;
    user-select: none;
    line-height: 1;

    &:hover {
        color: #2e3137;
    }

    @media only screen and (max-width: 768px) {
        display: inline-block;
    }
`;

export const lftBottomContent = css`
    display: flex;
    gap: 4px;

    @media only screen and (max-width: 768px) {
        width: 100% !important;
    }
`;

export const contactList = css`
    overflow-y: auto;
    z-index: 1;
    flex-grow: 1;
    padding: 0px 4px;
    border-bottom-left-radius: 12px;
    overscroll-behavior-y: contain;

    @media only screen and (max-width: 768px) {
        border-bottom-left-radius: 0 !important;
        flex: 1 !important;
        height: 100% !important;
    }
`;

export const contactItem = css`
    cursor: pointer;
    display: flex;
    align-items: center;
    border-radius: 12px;
    padding: 0px 8px;
    height: 56px;

    &:hover {
        background-color: #eff0f1;
    }
`;

export const selectedChatroom = css`
    background-color: #bcddff;
    &:hover {
        background-color: #bcddff;
    }
`;

export const chatImgWrapper = css`
    position: relative;
    margin-right: 8px;
    flex-shrink: 0;
    height: 26px;
`;

export const chatImg = css`
    width: 26px;
    height: 26px;
    border-radius: 50%;
`;

export const chatContent = css`
    flex-grow: 1;
    overflow: hidden;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 8px 0px;
`;

export const chatName = css`
    font-size: 12px;
    font-weight: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0px;
    line-height: 22px;
    width: auto;
    max-width: 100%;
    color: rgba(33, 33, 33, 0.96);
`;

export const chatNameBold = css`
    font-weight: bold;
`;

export const leftWrapper = css`
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;

    @media only screen and (max-width: 768px) {
        width: 100% !important;
        height: 100% !important;
        max-height: 100% !important;
        flex: 1 1 100% !important;
        overflow: hidden !important;
    }
`;

export const topist = css`
    display: flex;
    justify-content: flex-start;
    min-height: 56px;
    z-index: 1001;
    align-items: center;
    height: 56px;
    padding: 10px 8px 10px 16px;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 2px 4px 0px;
    justify-content: space-between;
`;

export const noActiveChatTopist = css`
    justify-content: flex-end;
`;

export const closeWrapper = css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 44px;
    padding-right: 8px;
`;

export const emptyChatroomWrapper = css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    padding: 24px;
`;

export const chatUserWrapper = css`
    display: flex;
`;

export const userAvatar = css`
    flex: 0 0 auto;
    width: 36px;
    height: 36px;
    position: relative;
    cursor: pointer;
`;

export const headerImg = css`
    border-radius: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const userInfo = css`
    flex-grow: 1;
    margin-left: 8px;
    width: calc(100% - 164px);
    cursor: pointer;

    p {
        margin: 0px;
        font-size: 10px;
        color: rgba(33, 33, 33, 0.68);
        font-weight: 400;
        line-height: 13px;
    }
`;

export const userName = css`
    display: flex;
    align-items: center;

    p {
        color: #525867;
        font-weight: bold;
        line-height: 22px;
        margin: 0px 4px 0px 0px;
        font-size: 14px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
`;

export const chatroomWrapper = css`
    display: flex;
    flex-direction: column;
    height: calc(100% - 56px);
    position: relative;
`;

export const chatroom = css`
    position: relative;
    flex-grow: 1;
    padding: 0px 16px;
    overflow-y: auto;
    overscroll-behavior-y: contain;
`;

export const chatbox = css`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const chatItem = css`
    margin-top: 8px;
    display: flex;
    position: relative;
`;

export const chatItemLeft = css`
    justify-content: flex-start;
`;

export const chatItemRight = css`
    justify-content: flex-end;
`;

export const chatBubble = css`
    display: flex;
    flex-direction: column;
    max-width: 70%;
    position: relative;
`;

export const chatBubbleInner = css`
    position: relative;
    color: rgba(33, 33, 33, 0.96);
    text-align: left;
    display: inline-block;
    padding: 6px 12px;
    max-width: 330px;
    &:first-child {
        margin-top: 0px;
    }
`;

export const chatBubbleInnerRight = css`
    position: relative;
    color: rgba(33, 33, 33, 0.96);
    text-align: left;
    display: inline-block;
    padding: 6px 12px;
    max-width: 330px;
    border: none;
    background-color: #f0f3f7;
    border-radius: 20px 0px 20px 20px;
    &:first-child {
        margin-top: 0px;
    }
`;

export const chatBubbleInnerLeft = css`
    position: relative;
    color: rgba(33, 33, 33, 0.96);
    text-align: left;
    display: inline-block;
    padding: 6px 12px;
    max-width: 330px;
    border: solid 1px #f0f3f7;
    background-color: #ffffff;
    border-radius: 0px 20px 20px;
    &:first-child {
        margin-top: 0px;
    }
`;

export const chatBubbleRight = css`
    justify-content: flex-end;
`;

export const chatBubbleLeft = css`
    justify-content: flex-start;
`;

export const chatText = css`
    word-break: break-word;
    font-size: 13px;
    line-height: 20px;
    display: inline;
    white-space: pre-line;
`;

export const chatTextRight = css`
    word-break: break-word;
    font-size: 13px;
    line-height: 20px;
    display: inline;
    white-space: pre-line;
`;

export const chatTextInner = css`
    display: inline;
    span {
        color: rgba(33, 33, 33, 0.96);
    }
`;

export const chatTimeStatus = css`
    float: right;
    margin: 4px 0px 0px 8px;
`;

export const chatTimeStatusRight = css`
    float: right;
    margin: 0px 0px 0px 8px;
`;

export const chatTimeStatusInner = css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: -2px;
`;

export const timeText = css`
    color: rgba(33, 33, 33, 0.44);
    font-size: 11px;
    margin-left: 0px;
    line-height: 16px;
`;

export const actionContainer = css`
    box-shadow: rgba(0, 0, 0, 0.08) 0px -1px 2px 0px;
    padding: 10px 16px;
`;

export const actionWrapper = css`
    display: flex;
    align-items: flex-end;
`;

export const inputContainer = css`
    position: relative;
    flex-grow: 1;
    width: calc(100% - 42px);
    display: flex;
    align-items: flex-end;
`;

export const textareaContainer = css`
    position: relative;
    flex-grow: 1;
    display: flex;
`;

export const chatboxInput = css`
    position: relative;
    display: grid;
    background-color: #f0f3f7;
    border: none;
    border-radius: 20px;
    width: 100%;
`;

export const chatTextbox = css`
    resize: none;
    background-color: #ffffff;
    width: 100%;
    margin-bottom: 0px;
    line-height: 20px;
    color: #40444e;
    overflow-x: hidden;
    border: 1px solid #f0f3f7 !important;
    border-radius: 20px !important;
    padding: 10px 34px 10px 40px !important;
    font-size: 13px !important;
    font-family: inherit;
    outline: none;

    &:focus {
        border-color: #009faa !important;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

export const btnSendMessage = css`
    height: 42px;
    width: 42px;
    border: none;
    padding: 0px;
    margin-left: 8px;
    border-radius: 50%;
    background-color: #00aa5b;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;

    &:hover:not(:disabled) {
        background-color: #00994d;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

export const sendIcon = css`
    display: inline-block;
    vertical-align: middle;
`;

export const imageUploader = css`
    position: absolute;
    bottom: 9px;
    left: 9px;
    z-index: 1;
`;

export const chatUploadProgressBubble = css`
    padding: 12px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    min-height: 80px;
`;

export const uploadProgressCircle = css`
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const progressPercent = css`
    font-size: 12px;
    font-weight: 600;
    color: #40444e;
`;

export const chatImage = css`
    overflow: hidden;
    position: relative;
    border-radius: 0px 20px 20px;
    margin-top: 4px;
    display: inline-block;
    max-width: 100%;
`;

export const chatImageImg = css`
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
    cursor: pointer;
    max-width: 300px;
`;

export const chatTimeImage = css`
    position: absolute;
    right: 12px;
    bottom: 8px;
`;

export const chatImageContainer = css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: -2px;
`;

export const chatImageSpan = css`
    color: #ffffff;
    font-size: 11px;
    margin-left: 0px;
    line-height: 16px;
`;

export const dayBreak = css`
    margin: 8px 0 6px;
    span {
        font-size: 11px;
    }
`;

// Mobile responsive overrides for various elements
export const mobileOverrides = css`
    @media only screen and (max-width: 768px) {
        ${filterist} {
            min-height: 60px !important;
            padding: 8px !important;
        }

        ${lftTopContent} {
            margin-bottom: 8px !important;

            h1 {
                font-size: 14px !important;
            }
        }

        ${lftBottomContent} {
            width: 100% !important;

            .ant-input-search {
                width: 100% !important;
            }
        }

        ${contactItem} {
            height: 50px !important;
            padding: 0px 6px !important;
        }

        ${chatImgWrapper} {
            height: 24px !important;
            margin-right: 6px !important;
        }

        ${chatImg} {
            width: 24px !important;
            height: 24px !important;
        }

        ${chatContent} {
            padding: 6px 0px !important;
        }

        ${chatName} {
            font-size: 11px !important;
            line-height: 18px !important;
        }

        ${topist} {
            min-height: 50px !important;
            height: 50px !important;
            width: 100% !important;
            padding: 8px 6px 8px 12px !important;
        }

        ${chatUserWrapper} {
            width: 100% !important;
            flex: 1 !important;
            min-width: 0 !important;
        }

        ${userAvatar} {
            width: 32px !important;
            height: 32px !important;
            flex-shrink: 0 !important;
        }

        ${userInfo} {
            margin-left: 6px !important;
            width: calc(100% - 120px) !important;
            min-width: 0 !important;
            flex: 1 !important;

            p {
                font-size: 9px !important;
                line-height: 12px !important;
            }
        }

        ${userName} {
            p {
                font-size: 13px !important;
                line-height: 20px !important;
            }
        }

        ${leftWrapper} {
            width: 100% !important;
        }

        ${chatroom} {
            padding: 0px 12px !important;
        }

        ${chatItem} {
            margin-top: 6px !important;
        }

        ${chatBubble} {
            max-width: 85% !important;
        }

        ${chatBubbleInnerRight}, ${chatBubbleInnerLeft} {
            padding: 5px 10px !important;
            max-width: 280px !important;
        }

        ${chatText}, ${chatTextRight} {
            font-size: 12px !important;
            line-height: 18px !important;
        }

        ${chatTimeStatus}, ${chatTimeStatusRight} {
            margin: 2px 0px 0px 6px !important;
        }

        ${timeText} {
            font-size: 10px !important;
            line-height: 14px !important;
        }

        ${actionContainer} {
            padding: 8px 12px !important;
        }

        ${btnSendMessage} {
            height: 38px !important;
            width: 38px !important;
            margin-left: 6px !important;
        }

        ${inputContainer} {
            width: calc(100% - 38px) !important;
        }

        ${chatTextbox} {
            padding: 8px 30px 8px 36px !important;
            font-size: 12px !important;
        }

        ${imageUploader} {
            bottom: 7px !important;
            left: 7px !important;
        }

        ${chatImageImg} {
            max-width: 250px !important;
        }

        ${dayBreak} {
            margin: 8px 0 6px !important;

            span {
                font-size: 11px !important;
            }
        }
    }
`;

export const backToContacts = css`
    display: none;
    @media only screen and (max-width: 768px) {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 8px;
        cursor: pointer;
        padding: 4px;
        font-size: 18px;
        color: #525867;
    }
`;
